var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShifts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "novedades_main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 34,
    height: 34,
    transform: "translate(767 692)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 26.215,
    height: 24.378,
    fill: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_20",
    "data-name": "Mask Group 20",
    transform: "translate(-767 -692)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(771.385 697.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M0,15.764a5.139,5.139,0,0,1,.53-.68q3.907-3.606,7.829-7.2A1.473,1.473,0,0,1,10.9,9.018c-.01.78,0,1.56,0,2.374h.38q2.333,0,4.666,0c.665,0,.952.288.954.953,0,.932,0,1.864,0,2.886l7.37-6.764L16.9,1.7v.389c0,.859,0,1.718,0,2.577a.776.776,0,0,1-.839.865q-5.775.006-11.55,0a.774.774,0,0,1-.829-.742.8.8,0,0,1,.8-.818c.108-.008.217,0,.326,0H15.335c0-.858-.007-1.682,0-2.505A1.439,1.439,0,0,1,16.679.006a1.592,1.592,0,0,1,1.255.514q2.012,1.86,4.035,3.708L25.79,7.735c.56.514.568.942.014,1.451q-3.976,3.652-7.955,7.3a1.466,1.466,0,0,1-2.516-1.093c0-.793,0-1.587,0-2.435h-.351q-2.349,0-4.7,0c-.659,0-.948-.294-.949-.959,0-.931,0-1.862,0-2.878L1.966,15.883l7.344,6.74c.011-.135.024-.223.024-.31,0-.859,0-1.718,0-2.577,0-.629.288-.92.916-.92q4.992,0,9.983,0c.583,0,.925.288.927.77s-.349.794-.947.795q-4.421,0-8.842,0H10.9v.787c0,.533,0,1.066,0,1.6a1.448,1.448,0,0,1-1.222,1.567.411.411,0,0,0-.085.045H9.267a5.314,5.314,0,0,1-.963-.564Q4.387,20.254.5,16.657a4.25,4.25,0,0,1-.5-.7v-.2",
    transform: "translate(0 0)",
    fill: "#707070"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShifts);
export default __webpack_public_path__ + "static/media/icon_shifts.8e1e44ef77860cd426f8009c0b43bee1.svg";
export { ForwardRef as ReactComponent };